// Decorative animated equalizer bars (CSS-driven, aria-hidden).
export const MiniEq = ({ bars = 5, className = 'h-4' }) => (
    <div className={`flex items-end gap-[3px] ${className}`} aria-hidden="true">
        {Array.from({ length: bars }).map((_, i) => (
            <span
                key={i}
                className="eq-bar h-full w-[3px] rounded-full bg-aqua/70"
                style={{
                    animationDelay: `${i * 0.18}s`,
                    animationDuration: `${1 + (i % 3) * 0.35}s`,
                }}
            />
        ))}
    </div>
);
